import {useGetAndSet} from "./useGetAndSet";
import {createSetCapTotalsAction} from "../actions/dataActions";


export const useCapTotalChangesData = (params, dataFresh) => {
    return useGetAndSet("captotalchange", params, createSetCapTotalsAction, dataFresh);
}